import Confimar from "../../components/Confirmar";
const ComponenDev = () => {
    return (
        <div style={{ backgroundColor: 'red' }}>
            <Confimar/>
        </div>
    );
}
export default ComponenDev;